import moment from 'moment';

import {
    CANCEL_DELETE_SERVICE_DATA,
    CANCEL_OPERATION,
    DELETE_SERVICE_DATA,
    END_OPERATION,
    SAVE_SERVICE_DATA,
    START_OPERATION,
    SINGLE_OPERATION,
    UPDATE_AIRPORT_SERVICE,
    UPDATE_SENDED_SERVICE_DATA,
} from '../actions/airportServices';
import { CLEAR_SENDED_DATA_LIST } from '../actions/sended-data';
import { LOGOUT } from '../actions/screen';

const initialState = {};

const setService = (state, legId, id, service) => {
    const newService = state[legId] && state[legId][id];

    if (newService) {
        state[legId] = {
            ...state[legId],
            [id]: Object.assign({}, newService, service),
        };
    }

    return state;
};

export default (state = initialState, action) => {
    let newState = { ...state };

    switch (action.type) {
        case UPDATE_AIRPORT_SERVICE: {
            return Object.assign({}, newState, action.data);
        }
        case SAVE_SERVICE_DATA: {
            const { legId, service } = action;

            return setService(newState, legId, service.id, service);
        }
        case START_OPERATION: {
            const { legId, id } = action;

            const newService = {
                dateBeginReal: moment.utc(),
                isEdited: true,
            };

            return setService(newState, legId, id, newService);
        }
        case SINGLE_OPERATION: {
            const { legId, id } = action;

            const newService = {
                dateBeginReal: moment.utc(),
                dateEndReal: moment.utc(),
                isEdited: true,
            };

            return setService(newState, legId, id, newService);
        }
        case CANCEL_OPERATION: {
            const { legId, id } = action;

            const newService = {
                dateBeginReal: null,
                dateEndReal: null,
                isEdited: true,
            };

            return setService(newState, legId, id, newService);
        }
        case END_OPERATION: {
            const { legId, id } = action;

            const newService = {
                dateEndReal: moment.utc(),
                isEdited: true,
            };

            return setService(newState, legId, id, newService);
        }
        case DELETE_SERVICE_DATA: {
            const { legId, id } = action;

            const newService = {
                isRemoved: true,
            };

            return setService(newState, legId, id, newService);
        }
        case CANCEL_DELETE_SERVICE_DATA: {
            const { legId, id } = action;

            const newService = {
                isRemoved: false,
            };

            return setService(newState, legId, id, newService);
        }
        case CLEAR_SENDED_DATA_LIST: {
            if (action.ids) {
                action.ids.forEach((id) => {
                    delete newState[id];
                });
            }

            return newState;
        }
        case UPDATE_SENDED_SERVICE_DATA:
            Object.keys(action.legsData).forEach((legId) => {
                const airportServicesSended = action.legsData[legId].airportServices || [];

                airportServicesSended.forEach((sendedItem) => {
                    if (sendedItem) {
                        const { id, isUpdated, isDeleted } = sendedItem;
                        const { isEdited: edited = false, isRemoved = false } = (newState[legId] && newState[legId][id]) || {};
                        const isEdited = edited && !isRemoved;
                        delete sendedItem.isUpdated;
                        delete sendedItem.isDeleted;

                        if (isEdited) {
                            if (isUpdated) {
                                newState[legId] = {
                                    ...newState[legId],
                                    [id]: {
                                        ...newState[legId][id],
                                        isEdited: false,
                                    },
                                };
                            }
                        }

                        if ((isEdited || isRemoved) && isDeleted) {
                            newState[legId] = {
                                ...newState[legId],
                            };

                            delete newState[legId][id];
                        }

                        if ((isEdited && !isUpdated) || (isRemoved && !isDeleted)) {
                            newState[legId] = {
                                ...newState[legId],
                                [id]: {
                                    ...sendedItem,
                                    isEdited: false,
                                    isRemoved: false,
                                },
                            };
                        }
                    }
                });
            });

            return newState;
        case LOGOUT:
            return Object.assign({}, initialState);
        default:
            return state;
    }
};
